export const MuiDrawer = (primary700 :string, primary800:string, contrastText: string) => ({
  styleOverrides: {
    root: {
      '& .MuiPaper-root': {
        backgroundColor: primary700,
        color: contrastText,
        height: '100vh',
        border: '0px',
      },
      '& .AppSlidingSubMenu-root': {
        backgroundColor: primary800,
        color: contrastText,
      },
      '& .MuiListItemIcon-root': {
        alignItems: 'center',
        color: contrastText,
      },
      '& .MuiListItem-root': {
        padding: '0px',
      },
    },
  },
});